<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre3" id="pgepubid00016">Section 3</h2>
<p class="calibre1">For half an hour after the departure of the little Charmeuse car with Sir Richmond and Dr. Martineau, the brass Mercury lay unheeded in the dusty roadside grass. Then it caught the eye of a passing child.</p>
<p class="calibre1">He was a bright little boy of five. From the moment when he caught the gleam of brass he knew that he had made the find of his life. But his nurse was a timorous, foolish thing. “You did ought to of left it there, Masterrarry,” she said.</p>
<p class="calibre1">“Findings ain’t keepings nowadays, not by no manner of means, Masterrarry.</p>
<p class="calibre1">“Yew’d look silly if a policeman came along arsting people if they seen a goldennimage.</p>
<p class="calibre1">“Arst yer ‘ow you come by it and look pretty straight at you.”</p>
<p class="calibre1">All of which grumblings Master Harry treated with an experienced disregard. He knew definitely that he would never relinquish this bright and lovely possession again. It was the first beautiful thing he had ever possessed. He was the darling of fond and indulgent parents and his nursery was crowded with hideous rag and sawdust dolls, golliwogs, comic penguins, comic lions, comic elephants and comic policemen and every variety of suchlike humorous idiocy and visual beastliness. This figure, solid, delicate and gracious, was a thing of a different order.</p>
<p class="calibre1">There was to be much conflict and distress, tears and wrath, before the affinity of that clean-limbed, shining figure and his small soul was recognized. But he carried his point at last. The Mercury became his inseparable darling, his symbol, his private god, the one dignified and serious thing in a little life much congested by the quaint, the burlesque, and all the smiling, dull condescensions of adult love.</p>
<p class="calibre1"><a id="link2HCH0004"></a></p>
<div class="calibre9" id="calibre_pb_3"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0009.vue?01fe9930